var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4907_67881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.57812 0 0 3.57812 0 8C0 12.4219 3.57812 16 8 16C12.4219 16 16 12.4219 16 8C16 3.57812 12.4219 0 8 0ZM12.5962 9.71625C12.3634 10.5016 11.9562 11.2291 11.3453 11.7816C10.7634 12.3053 10.0653 12.6544 9.30906 12.8287C8.46531 13.0325 7.59281 13.0325 6.77812 12.7997C6.13812 12.625 5.49812 12.305 4.97437 11.8978C4.42156 11.4616 3.95625 10.8797 3.63625 10.2397C3.14156 9.25063 2.99625 8.11594 3.2 7.03969C3.28719 6.60344 3.43281 6.19594 3.63625 5.78875C4.21812 4.65406 5.23625 3.7525 6.45813 3.31594C7.53438 2.93781 8.72719 2.96688 9.80344 3.345C10.3853 3.54875 10.9381 3.89781 11.4034 4.33406C11.2581 4.50875 11.0834 4.65406 10.9087 4.82875C10.6178 5.11969 10.2978 5.43969 10.0069 5.73063C9.71594 5.43969 9.33781 5.23594 8.93062 5.09062C8.46531 4.94531 7.94156 4.91594 7.47594 5.0325C6.92312 5.14875 6.39969 5.43969 5.99219 5.84719C5.67219 6.16719 5.41031 6.57438 5.265 7.01094C5.06125 7.62188 5.06125 8.32 5.265 8.93094C5.46875 9.54187 5.87594 10.0947 6.39969 10.4438C6.71969 10.6766 7.09781 10.8509 7.505 10.9091C7.88313 10.9963 8.29031 10.9672 8.69781 10.9091C9.07594 10.8509 9.45406 10.7053 9.80313 10.4728C10.3269 10.1237 10.705 9.57094 10.7922 8.93094H8.08687V7.01094H12.7416C12.8869 7.94188 12.8287 8.84375 12.5962 9.71625Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4907_67881"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.a2b4c32074601ff629d8f3b7f227503e.svg";
export { ForwardRef as ReactComponent };